import React, { useEffect, useContext } from "react";
import DatabaseContext from "data/contextDatabase";
import GlobalContext from "contexts/context";

const Database = (props) => {
  // Anything here acts as componentWillMount
  // eslint-disable-next-line
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const { globalState } = useContext(GlobalContext);

  useEffect(() => {
    // This runs after component is rendered ... first time. The [] indicates "no dependencies"
    // so this is like componentDidMount
    console.log("Database is rendered ... first time");

    const setReady = (error, key) => {
      console.log("setReady error, key: ", error, key);
      key &&
        setTimeout(function () {
          console.log("setReady key: ", key);
          databaseDispatch({
            type: "MASTER_DB_READY",
            values: { ready: true },
          });
        }, 1);
    };

    console.log("CREATE_MASTER_DB uid: ", globalState.uid);
    console.log("CREATE_MASTER_DB pwd: ", globalState.password);

    if (globalState.uid && globalState.password) {
      // databaseDispatch({
      //   type: "MASTER_DB_READY",
      //   values: { ready: false },
      // });
      databaseDispatch({
        type: "CREATE_MASTER_DB",
        values: {
          dbUrl: globalState.uid,
          pwd: globalState.uid + "-" + globalState.password,
          cb: setReady,
        },
      });
    }

    databaseDispatch({
      type: "CREATE_USER_DB",
      values: { dbUrl: props.dbUser },
    });

    return () => {
      console.log("Database runs componentWillUnmount for the last time");
    };
  }, [databaseDispatch, globalState.password, globalState.uid, props.dbUser]);

  let content = <div></div>;
  return content;
};

export default React.memo(Database, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
